/* tempexp_18086-start */
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { ReferralModalProps } from './ReferralModal';

export const renderReferralModal = ({ onClose, ...data }: ReferralModalProps) =>
    openPopupHelper({ popupName: popupNames.REFERRAL_MODAL, data, onClose });

export const closeReferralModal = () => closePopupHelper(popupNames.REFERRAL_MODAL);

/* tempexp_18086-end */
